import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GiftDetailsIdMappedInput, GiftView } from 'src/app/auth_profile/model/v3/transactions';
import { ColNativeV3Api } from './col-native-v3-api';
import {
  ApiLessonEventModel,
  ProductAvailabilityRequest,
  ScheduleDefinition,
  ScheduleReference,
  SimpleLessonScheduleRequest,
  SimpleProductAvailability,
  SimpleTeacherProductAvailability,
  StudentColLessonScheduleEvents,
  TeacherColLessonScheduleEvents,
} from '../../../model/v3/booking';
import { Page, Pageable } from '../../../../utils/pageable';
import * as LessonsV3 from '../../../model/v3/lessons';

@Injectable({
  providedIn: 'root'
})
export class UnsupportedColNativeV3ServiceApi
  implements ColNativeV3Api {
  getTeacherAvailability(
    schoolId: number,
    studentId: number,
    dateFrom?: Date | null,
    dateTo?: Date | null,
    productCode?: string | null
  ): Observable<SimpleTeacherProductAvailability[]> {
    throw new Error("Method not implemented.");
  }

  getStudentLessonSchedules(
    schoolId: number,
    studentId: number,
    dateFrom?: Date | null,
    dateTo?: Date | null,
    productCode?: string | null
  ): Observable<StudentColLessonScheduleEvents[]> {
    throw new Error("Method not implemented.");
  }

  reserveColLessonSchedule(
    schoolId: number,
    studentId: number,
    request: SimpleLessonScheduleRequest
  ): Observable<StudentColLessonScheduleEvents> {
    throw new Error("Method not implemented.");
  }

  getStudentSchedule(
    schoolId: number,
    studentId: number,
    scheduleId: number
  ): Observable<StudentColLessonScheduleEvents> {
    throw new Error("Method not implemented.");
  }

  updateColLessonEventData(
    schoolId: number,
    studentId: number,
    scheduleId: number,
    eventId: number,
    data: ApiLessonEventModel
  ): Observable<void> {
    throw new Error("Method not implemented.");
  }

  deleteColLesson(
    schoolId: number,
    studentId: number,
    scheduleId: number
  ): Observable<void> {
    throw new Error("Method not implemented.");
  }

  getAvailabilityEvents(
    schoolId: number,
    teacherId: number,
    dateFrom?: Date | null,
    dateTo?: Date | null,
    productCode?: string | null
  ): Observable<SimpleProductAvailability[]> {
    throw new Error("Method not implemented.");
  }

  getTeacherColLessonEvents(
    schoolId: number,
    teacherId: number,
    dateFrom?: Date | null,
    dateTo?: Date | null
  ): Observable<TeacherColLessonScheduleEvents[]> {
    throw new Error("Method not implemented.");
  }

  getTeacherCourseProfiles(
    schoolId: number,
    teacherId: number
  ): Observable<LessonsV3.V3CourseTeacherProfile[]> {
    throw new Error("Method not implemented.");
  }

  createAvailability(
    schoolId: number,
    teacherId: number,
    request: ProductAvailabilityRequest
  ): Observable<ScheduleReference> {
    throw new Error("Method not implemented.");
  }

  deleteAvailability(
    schoolId: number,
    teacherId: number,
    scheduleId: number
  ): Observable<void> {
    throw new Error("Method not implemented.");
  }

  deleteTeacherColLesson(
    schoolId: number,
    teacherId: number,
    scheduleId: number
  ): Observable<void> {
    throw new Error("Method not implemented.");
  }

  deleteAvailabilityEvent(
    schoolId: number,
    teacherId: number,
    scheduleId: number,
    eventId: number,
    deleteAll?: boolean | null
  ): Observable<void> {
    throw new Error("Method not implemented.");
  }

  updateAvailabilityEvent(
    schoolId: number,
    teacherId: number,
    scheduleId: number,
    eventId: number,
    definition: ScheduleDefinition,
    applyFuture?: boolean | null
  ): Observable<ScheduleDefinition> {
    throw new Error("Method not implemented.");
  }

  getStudentGifts(
    schoolId: number,
    studentId: number,
    unused?: boolean | null,
    platform?: string | null
  ): Observable<GiftView[]> {
    throw new Error("Method not implemented.");
  }

  createStudentGift(
    schoolId: number,
    studentId: number,
    details: GiftDetailsIdMappedInput,
    platform?: string | null
  ): Observable<GiftDetailsIdMappedInput> {
    throw new Error("Method not implemented.");
  }

  findLessons(
    type?: LessonsV3.LessonCategory | null,
    lessonType?: LessonsV3.LessonType | null,
    view?: string | null,
    eid?: string | null,
    studentId?: number | null,
    teacherId?: number | null,
    groupId?: number | null,
    groupEid?: string | null,
    productCode?: string | null,
    statuses?: LessonsV3.LessonStatus[] | null,
    dateFrom?: Date | null,
    dateTo?: Date | null,
    pageable?: Pageable | null
  ): Observable<Page<LessonsV3.LessonView>> {
    throw new Error("Method not implemented.");
  }

  getLesson(
    lessonId: number,
    view?: string | null,
    viewStudentId?: number | null
  ): Observable<LessonsV3.LessonView> {
    throw new Error("Method not implemented.");
  }

  getLessonMetric(lessonId: number): Observable<LessonsV3.V3LessonMetric> {
    throw new Error("Method not implemented.");
  }

  sendLessonNotification(lessonId: number): Observable<void> {
    throw new Error("Method not implemented.");
  }

  getLessonComment(
    lessonId: number,
    studentId?: number | null
  ): Observable<LessonsV3.ApiLessonMessage> {
    throw new Error("Method not implemented.");
  }

  updateLessonComments(
    lessonId: number,
    message: LessonsV3.LessonMessageDto,
    studentId?: number | null
  ): Observable<LessonsV3.ApiLessonMessage> {
    throw new Error("Method not implemented.");
  }

  getLessonFlags(lessonId: number): Observable<LessonsV3.ApiLessonFlag[]> {
    throw new Error("Method not implemented.");
  }

  createLessonFlag(
    lessonId: number,
    details: LessonsV3.LessonFlagDto,
    studentId?: number | null,
    teacherId?: number | null
  ): Observable<LessonsV3.ApiLessonFlag> {
    throw new Error("Method not implemented.");
  }

  deleteLessonFlag(lessonId: number, flagId: number): Observable<void> {
    throw new Error("Method not implemented.");
  }

  getLessonGroup(lessonId: number): Observable<LessonsV3.LessonGroupParticipant> {
    throw new Error("Method not implemented.");
  }

  getLessonTeacher(
    lessonId: number
  ): Observable<LessonsV3.LessonTeacherParticipant<LessonsV3.TeacherRef>> {
    throw new Error("Method not implemented.");
  }

  getLessonStudents(
    lessonId: number
  ): Observable<LessonsV3.LessonStudentParticipant<LessonsV3.StudentRef>[]> {
    throw new Error("Method not implemented.");
  }

  getLessonStudentProgress(
    lessonId: number,
    studentNumber: number
  ): Observable<LessonsV3.V3LessonParticipantProgressDetails> {
    throw new Error("Method not implemented.");
  }

  getLessonNotes(lessonId: number): Observable<Record<string, string>> {
    throw new Error("Method not implemented.");
  }

  getLessonProgress(lessonId: number): Observable<LessonsV3.LessonProgressDetails> {
    throw new Error("Method not implemented.");
  }

  updateLessonProgress(
    lessonId: number,
    progress: LessonsV3.LessonProgressDetailsDto,
    type?: LessonsV3.LessonProgressType | null
  ): Observable<LessonsV3.LessonProgressDetails> {
    throw new Error("Method not implemented.");
  }

  updateLessonType(
    lessonId: number,
    type: LessonsV3.LessonType
  ): Observable<void> {
    throw new Error("Method not implemented.");
  }

  updateLessonStatus(
    lessonId: number,
    actionOrStatus: LessonsV3.LessonStatusAction | LessonsV3.LessonStatus,
    request?: LessonsV3.LessonStatusRequestDto | null,
    studentId?: number | null,
    teacherId?: number | null,
    checkStatus?: boolean | null
  ): Observable<LessonsV3.LessonView | void> {
    throw new Error("Method not implemented.");
  }

  getPersonColSettings(personId: number): Observable<LessonsV3.PersonalSettings> {
    throw new Error("Method not implemented.");
  }

  updatePersonColSettings(
    personId: number,
    settings: LessonsV3.PersonalSettings
  ): Observable<LessonsV3.PersonalSettings> {
    throw new Error("Method not implemented.");
  }

  updatePersonIntroductionState(
    personId: number,
    state: LessonsV3.IntroductionState
  ): Observable<void> {
    throw new Error("Method not implemented.");
  }

  getStudentBundles(
    schoolId: number,
    studentId: number,
    pageable?: Pageable | null,
    productCode?: string | null,
    available?: boolean | null
  ): Observable<Page<LessonsV3.LessonBundle>> {
    throw new Error("Method not implemented.");
  }

  createStudentBundle(
    schoolId: number,
    studentId: number,
    details: LessonsV3.LessonBundleDetails
  ): Observable<LessonsV3.LessonBundle> {
    throw new Error("Method not implemented.");
  }

  updateStudentBundleExpiry(
    schoolId: number,
    studentId: number,
    bundleId: number,
    expiryDate: Date
  ): Observable<void> {
    throw new Error("Method not implemented.");
  }

  getStudentCommits(
    schoolId: number,
    studentId: number,
    pageable?: Pageable | null,
    productCode?: string | null,
    courseCode?: string | null,
    commitStatuses?: LessonsV3.LessonCommitStatus[] | null,
    lessonStatuses?: LessonsV3.LessonStatus[] | null
  ): Observable<Page<LessonsV3.LessonCommit>> {
    throw new Error("Method not implemented.");
  }

  getStudents(
    schoolId?: number | null,
    personId?: number | null,
    email?: string | null,
    studentIds?: number[] | null,
    pageable?: Pageable | null
  ): Observable<Page<LessonsV3.V3SchoolStudent>> {
    throw new Error("Method not implemented.");
  }

  getSchoolProducts(schoolId: number): Observable<LessonsV3.V3Product[]> {
    throw new Error("Method not implemented.");
  }

  getProductVariants(
    view?: string | null,
    platform?: string | null,
    variantCodes?: string[] | null,
    lang?: string | null,
    currency?: string | null,
    priceLists?: string[] | null,
    pageable?: Pageable | null
  ): Observable<Page<LessonsV3.ProductVariantPreview>> {
    throw new Error("Method not implemented.");
  }

  getProductCourses(
    schoolId: number,
    productCode: string
  ): Observable<LessonsV3.Course[]> {
    throw new Error("Method not implemented.");
  }

  getCourseCompetences(
    schoolId: number,
    productCode: string,
    courseCode: string
  ): Observable<LessonsV3.Competence[]> {
    throw new Error("Method not implemented.");
  }

  getCompetenceMappings(): Observable<LessonsV3.CompetenceMapping[]> {
    throw new Error("Method not implemented.");
  }

  getProvaContext(
    schoolId: number,
    studentId: number,
    productCode: string
  ): Observable<LessonsV3.ColProvaContextDetails> {
    throw new Error("Method not implemented.");
  }

  updateProvaContext(
    schoolId: number,
    studentId: number,
    productCode: string,
    context: LessonsV3.ColProvaContextDetails
  ): Observable<LessonsV3.ColProvaContextDetails> {
    throw new Error("Method not implemented.");
  }

  getProductContexts(
    schoolId: number,
    studentId: number,
    productCode?: string | null
  ): Observable<LessonsV3.ProductContextDetails[]> {
    throw new Error("Method not implemented.");
  }

  updateProductContext(
    schoolId: number,
    studentId: number,
    productCode: string,
    context: LessonsV3.ProductContextDetails
  ): Observable<void> {
    throw new Error("Method not implemented.");
  }

  getCourseContexts(
    schoolId: number,
    studentId: number,
    productCode: string,
    current?: boolean | null
  ): Observable<LessonsV3.ColCourseContext[]> {
    throw new Error("Method not implemented.");
  }
}
